const UPLOAD_VIEW_FIELD_MAP = {
	form_086: 'form_086',
	document_file: 'document_file',
	quota_document: 'quota',
};

function isUploadFileId(value) {
	return value !== null && value !== undefined && value !== '' && /^\d+$/.test(String(value));
}

export function collectOrderUploadIds(order) {
	const ids = {};

	if (isUploadFileId(order.document_file)) {
		ids.document_file = order.document_file;
	}

	const form086 = order.form_086 ?? order.form086;
	if (isUploadFileId(form086)) {
		ids.form_086 = form086;
	}

	if (isUploadFileId(order.quota)) {
		ids.quota = order.quota;
	}

	return ids;
}

export async function fetchOrderUploadUrls(http, order) {
	const ids = collectOrderUploadIds(order);
	if (!Object.keys(ids).length) {
		return {};
	}

	const formData = new FormData();
	Object.entries(ids).forEach(([key, value]) => {
		formData.append(key, value);
	});

	const response = await http.post('/uploads', formData);
	return response.data.data || {};
}

export function applyUploadUrlsToView(block, uploadUrls) {
	if (!Array.isArray(block) || !uploadUrls) {
		return;
	}

	block.forEach((panel) => {
		Object.entries(panel.values || {}).forEach(([fieldKey, item]) => {
			if (!item || item.type !== 'file') {
				return;
			}
			const uploadKey = UPLOAD_VIEW_FIELD_MAP[fieldKey];
			const viewUrl = uploadKey && uploadUrls[uploadKey];
			if (!viewUrl) {
				return;
			}
			item.value = viewUrl;
			item.authenticated = true;
			if (!item.file_name || /^\d+$/.test(String(item.file_name))) {
				item.file_name = item.name;
			}
		});
	});
}
